import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PPMU_SUBHEADER_COPY = defineFcm('ppmu_subheader_copy')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault({ experimentName: undefined })
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'PPMU',
		description: 'Dynamic experiment name for the PPMU modal subheading copy A/B test (CHANGE-98285).',
		template: { experimentName: 'ppmu_subheader_copy' },
		deprecated: 'FCM no longer in use — safe to delete after 2026-10-26',
	});
